import { useState } from 'react';
import { Button } from '@mui/material';
import * as Yup from 'yup';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { BuildingFloorUnitForm } from './building-floor-unit.form';
import { useFormContext } from 'react-hook-form';
import { BuildingFloorUnitFormWithDefaultValue } from './create-building-floor-with-default-unit-name';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';
import { ProjectType } from '../../../models/project';

interface CreateBuildingFloorButtonProps {
  projectID: number;
  buildingID?: number;
  floor: any;
  onUnitCreated: (data: any) => void;
  syncWithDux: any;
  projectTypeValue: any;
  existingData: any;
  projectStreet?: string;
  projectCommunityType?: string;
  floorNo?: number | string;
}

export const CreateBuildingFloorUnitButton = ({
  projectID,
  buildingID,
  floor,
  onUnitCreated,
  syncWithDux,
  projectTypeValue,
  existingData,
  projectStreet,
  projectCommunityType,
  floorNo,
}: CreateBuildingFloorButtonProps) => {
  const [newBuilding, setNewBuilding] = useState<any>();
  const { setValue } = useFormContext();

  // const isProjectTypeRES = projectTypeValue === "RES";
  const isProjectTypeRES = true;

  const normalizeAddress = (text: string) => text?.toLowerCase()?.trim()?.replace(/\s+/g, '');

  const validationSchema = Yup.object().shape({
    unitData: Yup.object().shape({
      unitName: Yup.string().required('Lot/Unit is required').max(9, 'Lot/Unit cannot exceed 9 characters'),
      jobsite: Yup.string().required('Jobsite is required'),
      lotType: isProjectTypeRES ? Yup.string().required('Lot type is required') : Yup.string().notRequired(),
      // jobNumber: Yup.string().required('Job Number is required'),
      address: Yup.string()
        .required('Address is required')
        .max(31, 'Address cannot exceed 31 characters')
        .test('address-duplicate', 'Address already exists.', (value) => {
          if (!value) return true;
          if (
            projectCommunityType === ProjectType.Buildings &&
            normalizeAddress(value) === normalizeAddress(projectStreet ?? '')
          ) {
            return true;
          }
          const allAddresses = existingData?.map((u: any) => normalizeAddress(u?.address));
          return !allAddresses?.includes(normalizeAddress(value));
        }),
    }),
  });

  const handleDialogClose = () => {
    setNewBuilding(undefined);
  };

  const handleAddBuildingFloor = () => {
    setNewBuilding({
      projectID,
      floorName: '',
      unitData: {
        unitName: '',
        jobsite: '',
        jobNumber: '',
        // createWO: false,
        // syncWithDUX: false,
        buildingPermit: '',
        lotType: '',
      },
    });
  };

  const transformData = (data: any) => {
    return {
      unitName: data.unitName,
      jobNumber: data.jobNumber,
      jobsite: data.jobsite,
      address: data.address,
      lotType: data?.lotType,
      squareFeet: !data?.squareFeet ? null : Number(data?.squareFeet),
      proctorResult: !data.proctorResult
        ? null
        : {
            proctorResultsID: data.proctorResult.proctorResultsID,
            unitID: 0,
            proctorFileName: data.proctorResult.proctorFileName,
          },
      // createWO: data.createWO,
      // syncWithDUX: data.syncWithDUX,
      buildingPermit: data.buildingPermit,

      // proctorResult:
      //   data.proctorResult?.map((result: any) => ({
      //     proctorResultsID: result.proctorResultsID,
      //     unitID: 0,
      //     proctorFileName: result.proctorFileName,
      //   })) || [],
    };
  };

  const formatSubmitData = (data: any) => {
    const { floorID } = floor;

    const transformedData = transformData(data.unitData);
    return { projectID, buildingID, floorID, ...transformedData };
  };

  const hideActionButtons = !!(projectID > 0);

  return (
    <>
      <GuardedComponent requiredPermissions={[UserPermissionName.ADD_UNIT]}>
        {hideActionButtons && (
          <Button
            className="btn btn-primary"
            variant="text"
            sx={{ p: 0, m: 0, mr: 1, ml: 3, mb: 2 }}
            onClick={handleAddBuildingFloor}
          >
            Add Lot/Unit
          </Button>
        )}
      </GuardedComponent>
      {newBuilding && (
        <SaveHookFormDialog
          title="CREATE LOT/UNIT"
          config={{
            saveConfig: projectsApiKeyStore.createLot(),
          }}
          data={newBuilding}
          onClose={handleDialogClose}
          onSaveCompleted={onUnitCreated}
          formatSubmitdata={formatSubmitData}
          size="xl"
          yupSchema={validationSchema}
        >
          <div className="popupNoBg">
            {/* <BuildingFloorUnitForm name="unitData" isEnabled={true} /> */}
            <BuildingFloorUnitFormWithDefaultValue
              name="unitData"
              syncWithDux={syncWithDux}
              isEnabled={true}
              projectTypeValue={projectTypeValue}
              existingData={existingData}
              projectStreet={projectStreet}
              projectCommunityType={projectCommunityType}
              floorNo={floorNo}
            />
          </div>
        </SaveHookFormDialog>
      )}
    </>
  );
};
